const styles = () => ({
  link: {
    alignItems: 'center',
    display: 'flex',
  },
});

export default styles;
